import PageTitle from "../Components/PageTitle";
import Seo from "../Components/Seo";

export default function CancellationPolicy() {
  return (
    <div className="mx-auto max-w-4xl rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100">
      <Seo
        title="Cancellation Policy"
        description="Read Calm Coast Hypnotherapy cancellation and rescheduling terms, including notice periods and fees."
        path="/cancellation-policy"
      />
      <PageTitle title={"Cancellation and Rescheduling Policy"} />

      <div className="space-y-4 text-slate-700">
        <p>
          To ensure all clients receive the best possible care, I ask that any changes to appointments be communicated
          as early as possible.
        </p>
        <p>
          <strong>Notice for cancellations/rescheduling:</strong> Please provide at least 48 hours&apos; notice if you
          need to cancel or reschedule a session. This allows the appointment slot to be offered to another client.
        </p>
        <p>
          <strong>Late cancellations/no-shows:</strong> Sessions cancelled with less than 48 hours&apos; notice, or
          missed sessions, may incur a cancellation fee equivalent to &pound;70.
        </p>
        <p>
          <strong>Emergency situations:</strong> I understand that unexpected events can happen. If an emergency
          prevents you from attending, please contact me as soon as possible to discuss options.
        </p>
        <p>
          <strong>Payment:</strong> Fees for sessions must be settled at the time of booking, or in accordance with
          the agreed payment schedule. Cancellation fees, if applicable, are payable in full.
        </p>
        <p>
          <strong>Rescheduling:</strong> I will always do my best to offer alternative times that suit both parties if
          a session needs to be moved.
        </p>
        <p>
          This policy is in place to respect everyone&apos;s time and to help maintain a smooth and professional therapy
          schedule. Thank you for your understanding and cooperation. Carly X
        </p>
      </div>
    </div>
  )
}
